var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-drawer',{attrs:{"title":"Contratos Activos","visible":_vm.visible,"direction":"rtl","size":"50%"},on:{"update:visible":function($event){_vm.visible=$event},"close":_vm.onDrawerClose}},[_c('el-row'),_c('rabbey-table-3',{attrs:{"data":_vm.ActiveContractsData,"columns":_vm.activeContractsColumns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }